<div class="error-modal-container">
  <div class="error-modal-icon">
    <mat-icon class="material-symbols-rounded outline">{{ data.icon || 'error' }}</mat-icon>
  </div>
  
  @if (data.title) {
    <h6 class="error-modal-title">{{ data.title | translate }}</h6>
  }
  
  <p class="error-modal-message">{{ data.message || 'error.messages.unexpectedError' | translate }}</p>
  
  <div class="error-modal-actions">
    <button class="btn btn-primary btn-full" (click)="onClose()">
      {{ data.buttonText || 'common.buttons.accept' | translate }}
    </button>
  </div>
</div>

